import { useCallback } from "react";
import { useHistory } from "react-router-dom";

/**
 * Hook that provides a callback function for cleaning up ca_source and ca_price URL parameters
 */
const useCaParamsCleanup = () => {
  const history = useHistory();

  return useCallback(() => {
    const currentUrlParams = new URLSearchParams(window.location.search);
    let needsUpdate = false;

    if (currentUrlParams.has("ca_source")) {
      currentUrlParams.delete("ca_source");
      needsUpdate = true;
    }

    if (currentUrlParams.has("ca_price")) {
      currentUrlParams.delete("ca_price");
      needsUpdate = true;
    }

    if (needsUpdate) {
      history.replace(`${window.location.pathname}?${currentUrlParams.toString()}${window.location.hash}`);
    }

    return needsUpdate;
  }, [history]);
};

export default useCaParamsCleanup;
